/** Lightweight edge haze — transform/opacity only, no CSS blur filters. */
export default function AtmosphericFog() {
  return (
    <div className="bk-fog pointer-events-none absolute inset-0 z-[2] overflow-hidden contain-strict" aria-hidden>
      <div className="bk-fog-side bk-fog-side--left">
        <div className="bk-fog-plume bk-fog-plume--1" />
      </div>
      <div className="bk-fog-side bk-fog-side--right">
        <div className="bk-fog-plume bk-fog-plume--1" />
      </div>
    </div>
  );
}
